import { Dialog, DialogContent, Typography, Button, Box } from '@mui/material';

const RegenerateSecretWarning = ({ open, onClose, onProceed }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent sx={{ p: 4, width: 420 }}>
        <Typography variant="h6" color="error">
          Regenerate Signing Secret?
        </Typography>

        <Typography sx={{ mt: 2 }} color="text.secondary">
          The current signing secret will stop working immediately. Any integrations using the old secret will fail to
          verify webhook signatures. This action cannot be undone.
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>

          <Button variant="contained" color="error" onClick={onProceed}>
            Proceed
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RegenerateSecretWarning;
